import { DismissSparklines } from '../../domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemoteDismissSparklines extends BaseHttpService<DismissSparklines.Model> implements DismissSparklines {
  async dismiss(body: DismissSparklines.Params): Promise<DismissSparklines.Model> {
    return await this.request('post', body);
  }
}
